import { Box, Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useContext } from 'react';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { ReconnectAccount } from './reconnectaccount/Index';
import { ProfilesAndPages } from './profilesandpages/Index';
import { env } from '../../../../core/Env';
import { fetchUserAuthDetails } from '../helpers/metricHelpers';

export const Insight = () => {
    const { tool_state, social_media_insight_state } = useContext(ToolContext);
    const selectedPlatform = social_media_insight_state.selectedPlatform.data;
    const { userId, __SESSION } = tool_state;
    const accountNotConnected = social_media_insight_state.accountNotConnected.data;
    const url = new URL(window.location.href);

    useEffect(() => {
        console.log("social_media_insight_state?.insightData?.data?.message: ", social_media_insight_state?.insightData?.data?.message);
        if (social_media_insight_state?.insightData?.data?.message !== 'success') {
            social_media_insight_state.accountNotConnected.set(false);
        } else {
            social_media_insight_state.accountNotConnected.set(true);
        }
    }, [social_media_insight_state?.insightData?.data?.message]);

    const handlePlatformSelect = async (platform) => {
        // if (platform === 'facebook' && social_media_insight_state.showProfilesModal.data) {
        //     return;
        // }
        // if (url.searchParams.get('code')) {
        //     const userAuthDetails = await fetchUserAuthDetails(__SESSION.data.uaccess[0].company_id, userId.data, '1');
        //     social_media_insight_state.selectedProfileId.set(userAuthDetails?.page_id);
        //     social_media_insight_state.accessToken.set(userAuthDetails?.access_token);
        //     social_media_insight_state.urlCode.set("true");
        // }
        url.searchParams.set('state', platform);
        url.searchParams.delete('code');
        window.history.pushState({}, '', url);
        social_media_insight_state.selectedPlatform.set(String(platform).charAt(0).toUpperCase() + String(platform).slice(1));
        social_media_insight_state.connectedPlatform.set(platform.toLowerCase());
    };

    useEffect(() => {
        if (social_media_insight_state.showProfilesModal.data) {
            social_media_insight_state.insightLoading.set(false);
            social_media_insight_state.topContentsLoading.set(false);
            social_media_insight_state.viewsLoading.set(false);
            social_media_insight_state.followsLoading.set(false);
            social_media_insight_state.reachLoading.set(false);
            social_media_insight_state.linkClicksLoading.set(false);
        }
    }, [social_media_insight_state.showProfilesModal.data]);

    const facebookAuthUrl = process.env.REACT_APP_FACEBOOK_AUTH_URL;
    const instagramAuthUrl = process.env.REACT_APP_INSTAGRAM_AUTH_URL;
    const linkedInAuthUrl = process.env.REACT_APP_LINKEDIN_AUTH_URL;

    const handleConnect = () => {
        console.log("handleConnect called !!!");
        if (accountNotConnected) {
            console.log("accountNotConnected : ", accountNotConnected);
            social_media_insight_state.showReconnectModal.set(true);
            return;
        }
        connectToPlatform();
    };

    const connectToPlatform = () => {
        console.log("connectToPlatform called !!!");
        social_media_insight_state.connectedPlatform.set(selectedPlatform.toLowerCase());
        console.log("selectedPlatform: ", selectedPlatform);
        if (selectedPlatform === 'Facebook') {
            console.log("facebookAuthUrl: ", facebookAuthUrl);
            window.open(facebookAuthUrl, '_self');
            console.log("Redirected !!!");
        } else if (selectedPlatform === 'Instagram') {
            console.log("instagramAuthUrl: ", instagramAuthUrl);
            window.open(instagramAuthUrl, '_self');
            console.log("Redirected !!!");
        } else if (selectedPlatform === 'LinkedIn') {
            console.log("linkedInAuthUrl: ", linkedInAuthUrl);
            window.open(linkedInAuthUrl, '_self');
            console.log("Redirected !!!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const url = new URL(window.location.href);
            let code = url.searchParams.get('code') || '';

            if (url.hash) {
                code += url.hash;
            }
            if (code) {
                try {
                    const stateParam = url.searchParams.get('state')?.toLocaleLowerCase();
                    if (stateParam === 'facebook') {
                        social_media_insight_state.showProfilesModal.set(true);
                    }
                    let bdy = { code: code, user_id: userId.data, company_id: __SESSION.data.uaccess[0].company_id };
                    social_media_insight_state.profilePagesLoading.set(true);
                    const response = await rqx.post(`<<tool>>/${env()}/${stateParam}Insights/connect_${stateParam}_account`, bdy);
                    if (response?.message === 'success') {
                        if (stateParam === 'facebook') {
                            social_media_insight_state.profilePages.set(response?.data?.available_pages || []);
                            social_media_insight_state.showProfilesModal.set(true);
                        }
                        url.searchParams.delete('code');
                        window.history.replaceState({}, '', url);
                        setTimeout(() => {
                            social_media_insight_state.urlCode.set("true");
                        }, 100);
                    } else {
                        social_media_insight_state.showProfilesModal.set(false);
                        console.error('API response was not successful:', response?.details?.message);
                    }
                    // social_media_insight_state?.urlCode?.set(code);
                } catch (error) {
                    social_media_insight_state.showProfilesModal.set(false);
                    console.error('Error connecting account:', error);
                } finally {
                    social_media_insight_state.profilePagesLoading.set(false);
                }
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const url = new URL(window.location.href);
        const platform = url.searchParams.get('state');
        if (platform) {
            handlePlatformSelect(platform);
        }
    }, []);

    return (
        <Box mb={{ xs: 2, sm: '48px' }}>
            <Box fontSize={{ xs: 20, sm: 24 }} fontWeight={600} mb='34px'>
                Social Media Insights
            </Box>
            <Box
                display="flex"
                flexDirection={{ xs: 'column', sm: 'row' }}
                justifyContent="space-between"
                flexWrap="wrap"
                alignItems={{ xs: 'stretch', sm: 'center' }}
                gap={{ xs: 2, sm: 2 }}
            >
                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    gap={{ xs: 1, sm: 2 }}
                    width={{ xs: '100%', sm: 'auto' }}
                >
                    <Button
                        variant={social_media_insight_state.selectedPlatform.data === 'Facebook' ? 'contained' : 'outlined'}
                        onClick={() => handlePlatformSelect('Facebook')}
                        disabled={social_media_insight_state.topContentsLoading.data || social_media_insight_state.insightLoading.data && social_media_insight_state.insightLoading.data || social_media_insight_state.linkClicksLoading.data}
                        sx={{
                            borderRadius: '10px',
                            width: { xs: '100%', sm: '140px' },
                            height: '40px',
                            alignItems: 'center',
                            fontSize: { xs: 14, sm: 16 }
                        }}
                        fullWidth={true}
                    >
                        Facebook
                    </Button>
                    <Button
                        variant={social_media_insight_state.selectedPlatform.data === 'Instagram' ? 'contained' : 'outlined'}
                        onClick={() => handlePlatformSelect('Instagram')}
                        disabled={social_media_insight_state.topContentsLoading.data || social_media_insight_state.insightLoading.data || social_media_insight_state.linkClicksLoading.data}
                        sx={{
                            borderRadius: '10px',
                            width: { xs: '100%', sm: '140px' },
                            height: '40px',
                            alignItems: 'center',
                            fontSize: { xs: 14, sm: 16 }
                        }}
                        fullWidth={true}
                    >
                        Instagram
                    </Button>
                    <Button
                        variant={social_media_insight_state.selectedPlatform.data === 'LinkedIn' ? 'contained' : 'outlined'}
                        onClick={() => handlePlatformSelect('LinkedIn')}
                        disabled={social_media_insight_state.topContentsLoading.data || social_media_insight_state.insightLoading.data}
                        // disabled={true}
                        sx={{
                            borderRadius: '10px',
                            width: { xs: '100%', sm: '140px' },
                            height: '40px',
                            alignItems: 'center',
                            fontSize: { xs: 14, sm: 16 }
                        }}
                        fullWidth={true}
                    >
                        LinkedIn
                    </Button>
                </Box>
                <Button
                    variant="contained"
                    sx={{
                        background: '#333333',
                        borderRadius: '10px',
                        width: { xs: '100%', sm: '207px' },
                        height: '40px',
                        alignItems: 'center',
                        fontSize: { xs: 14, sm: 16 },
                        mt: { xs: 2, sm: 0 },
                        fontWeight: 700
                    }}
                    fullWidth={true}
                    onClick={() => handleConnect()}
                    disabled={social_media_insight_state.topContentsLoading.data || social_media_insight_state.insightLoading.data || social_media_insight_state.linkClicksLoading.data}
                >
                    Connect to {social_media_insight_state.selectedPlatform.data}
                </Button>

            </Box>

            {social_media_insight_state.showReconnectModal.data && (
                <ReconnectAccount
                    onConnect={connectToPlatform}
                />
            )}

            {(social_media_insight_state.showProfilesModal.data && url.searchParams.get('state')?.toLowerCase() === 'facebook') && (
                <ProfilesAndPages />
            )}
        </Box>
    );
};